import Preloader from '../preloader'

export class FetchData {
  constructor () {}

  /**
   * @param body {Object}
   * @param url {String}
   * */
  static async postData (body, url, isNeedPreloader=true) {
    isNeedPreloader && Preloader.display()
    const stringBody = JSON.stringify(body)
    try {
      const request = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: stringBody
      })
      if (request.ok) {
        const response = await request.json()

        if (response.modal) {
          $.fancybox.close()
          $.fancybox.open({
            src: $(response.modal),
            type: 'inline',
            opts: {
              afterClose: function (instance, current) {
                if (current.src[0].dataset.hasOwnProperty('jsReloadPage')) {
                  window.location.reload()
                }
              }
            }
          })
        }
        return response
      } else {
        $.fancybox.close()
        $.fancybox.open({
          src: '#modal-error',
          type: 'inline'
        })
      }
    } catch (err) {
      $.fancybox.close()
      $.fancybox.open({
        src: '#modal-error',
        type: 'inline'
      })
      isNeedPreloader && Preloader.hide()
    }
  }

  /**
   * @param url {String}
   * @param isNeedPreloader
   * */

  static async getData (url, isNeedPreloader = true) {
    isNeedPreloader && Preloader.display()
    try {
      const request = await fetch(url)
      if (request.ok) {
        const response = await request.json()

        if (response.modal) {
          $.fancybox.close()
          $.fancybox.open({
            src: $(response.modal),
            type: 'inline',
            opts: {
              afterClose: function (instance, current) {
                if (current.src[0].dataset.hasOwnProperty('jsReloadPage')) {
                  window.location.reload()
                }
              }
            }
          })
        }

        return response
      } else {
        $.fancybox.close()
        $.fancybox.open({
          src: '#modal-error',
          type: 'inline'
        })
      }
    } catch (err) {
      $.fancybox.close()
      $.fancybox.open({
        src: '#modal-error',
        type: 'inline'
      })
    }
  }
}
